import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Loader2, ShieldCheck } from 'lucide-react';
import { setAuth, clearAuth, ping } from '../api/client';

export const LoginGate = ({ onAuthed }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setAuth(username, password);
    try {
      await ping();
      onAuthed();
    } catch (err) {
      clearAuth();
      setError('Invalid credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex items-center justify-center px-4">
      <Card className="w-full max-w-md bg-slate-900 border-slate-800 text-slate-100">
        <CardHeader className="text-center">
          <div className="mx-auto mb-3 w-12 h-12 rounded-full bg-emerald-500/10 border border-emerald-500/40 flex items-center justify-center">
            <ShieldCheck className="w-6 h-6 text-emerald-400" />
          </div>
          <CardTitle className="text-2xl">Evidence Portal</CardTitle>
          <CardDescription className="text-slate-400">
            Internal EPD assessor tool. Authorised access only.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4" data-testid="evidence-login-form">
            <div>
              <Label htmlFor="ev-user" className="text-slate-300">Username</Label>
              <Input
                id="ev-user"
                data-testid="evidence-username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="bg-slate-800 border-slate-700 text-slate-100"
                autoComplete="username"
              />
            </div>
            <div>
              <Label htmlFor="ev-pass" className="text-slate-300">Password</Label>
              <Input
                id="ev-pass"
                data-testid="evidence-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="bg-slate-800 border-slate-700 text-slate-100"
                autoComplete="current-password"
              />
            </div>
            {error && (
              <p className="text-sm text-red-400" data-testid="evidence-login-error">{error}</p>
            )}
            <Button
              type="submit"
              disabled={loading}
              data-testid="evidence-login-submit"
              className="w-full bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-medium"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Sign In'}
            </Button>
          </form>
          <p className="mt-6 text-xs text-slate-500 leading-relaxed">
            This portal is separate from the public EPD website. All actions are logged. Files
            uploaded here are private and never publicly accessible.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
